import React, { useContext, useState } from "react";
import { ThemeContext } from "../app/App";
import { timespanOptions, TopItemsData, TopItemsTimespan, TopItemsType } from "../spotify/spotify";
import ArtistList from "./ArtistList";
import GenreList from "./GenreList";
import SongList from "./SongList";




interface RecapInfoProps {
    topItemsData: TopItemsData;
}

const typeOptions: TopItemsType[] = ["tracks", "artists", "genres"];
const timespanLabels: Record<TopItemsTimespan, string> = {
    "short_term": "last month",
    "medium_term": "last 6 months",
    "long_term": "several years"
};

const RecapInfo: React.FC<RecapInfoProps> = ({ topItemsData }) => {
    const { theme } = useContext(ThemeContext);
    const [ type, setType ] = useState<TopItemsType>("tracks");
    const [ timespan, setTimespan ] = useState<TopItemsTimespan>("short_term");

    return (
        <div className="w-screen column-centered">
            <div className="flex">
                <p className="text-2xl mr-2">top</p>
                {
                    typeOptions.map(typeOpt => 
                        <p key={typeOpt} className={`text-2xl cursor-pointer ${typeOpt === type ? '' : 'opacity-30'} mr-2`}
                            onClick={() => setType(typeOpt)}>{typeOpt}</p>
                    )
                }
            </div>
            <div className="flex justify-around my-2 mx-1 space-x-5">
                {
                    timespanOptions.map(timespanOpt => 
                        <p key={timespanOpt} className={`text-lg md:text-xl text-center cursor-pointer ${timespanOpt === timespan ? '' : 'opacity-30'}`}
                            onClick={() => setTimespan(timespanOpt)}>{timespanLabels[timespanOpt]}</p>
                    )
                }
            </div>
            <div className={`border-b-2 opacity-25 ${theme === "dark" ? "border-white" : "border-gray-700"} w-1/2 mb-4 mt-1 mx-auto`} />
            { type === "tracks" && <SongList songs={topItemsData["tracks"][timespan]} /> }
            { type === "artists" && <ArtistList artists={topItemsData["artists"][timespan]} /> }
            { type === "genres" && <GenreList genreCounts={topItemsData["genres"][timespan]} /> }
        </div>
    )
}

export default RecapInfo;
